import React from "react";
import "./HowFreeTrialWorks.css";

import image1 from "../assets/png/Rectangle 3466209.png";
import image2 from "../assets/png/Rectangle 3466210.png";
import image3 from "../assets/png/Rectangle 3466211.png";
import image4 from "../assets/png/Rectangle 3466212.png";
import image5 from "../assets/png/Rectangle 3466213.png";
import image6 from "../assets/png/Rectangle 3466214.png";

import { Text } from "@jds/core";

const HowFreeTrialWorks = () => {
  const bodyItems = [
    "Your first event creation is completely free",
    "You'll get 25 GB of storage to use during the trial",
    "The free trial lasts for 30 days",
    "The trial begins the day you create your first event",
    "After 30 days, you'll need to subscribe to continue accessing your event storage",
  ];
  return (
    <>
      <div className="main-cont">
        <div className="free-trial-left">
          <div style={{ marginTop: "40px" }}>
            <Text text="How free trials work" appearance="heading_xs" />
          </div>
          <div style={{ maxWidth: "484px" }}>
            <ul className="free-trial-body-list">
              {bodyItems.map((item, index) => (
                <li key={index}>{<Text text={item} appearance="body_s" />}</li>
              ))}
            </ul>
          </div>
        </div>
        {/* <div className="free-trial-right"> */}
        <div className="free-trial-right">
          <div className="fancy-gradient">
            <div className="image-container">
              <img src={image1} />
            </div>
            <div className="image-container">
              <img src={image2} />
            </div>
            <div className="image-container">
              <img src={image3} />
            </div>
            <div className="image-container">
              <img src={image4} />
            </div>
            <div className="image-container">
              <img src={image5} />
            </div>
            <div className="image-container">
              <img src={image6} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HowFreeTrialWorks;
